import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useLanding } from '@/components/Landing/LandingKit';
import { EditorialLink } from '@/components/Landing/LandingValueStory';
import { ABOUT_PRINCIPLES, STORY_PARAGRAPHS } from '@/constants/aboutContent';
import { AboutBody, AboutSection, AboutSplit, AboutTitle } from './AboutKit';

function AboutStory() {
  const { c, isCompact } = useLanding();
  return (
    <AboutSection label="Our company and principles">
      <AboutSplit>
        <View style={{ flex: isCompact ? undefined : 0.8, minWidth: 0 }}>
          <AboutTitle>Why we’re here.</AboutTitle>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.6, minWidth: 0 }}>
          <View style={{ gap: 20 }}>
            {STORY_PARAGRAPHS.map(paragraph => <AboutBody key={paragraph}>{paragraph}</AboutBody>)}
          </View>
          <View style={{ marginTop: 34, borderTopWidth: 1, borderTopColor: c.rule }}>
            {ABOUT_PRINCIPLES.map(principle => (
              <View key={principle.title} style={{ paddingVertical: 22, borderBottomWidth: 1, borderBottomColor: c.rule }}>
                <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 18, lineHeight: 25, letterSpacing: -0.25 }}>{principle.title}</Text>
                <AboutBody style={{ fontSize: 15, lineHeight: 25, marginTop: 8 }}>{principle.copy}</AboutBody>
                {principle.href ? <EditorialLink href={principle.href} style={{ marginTop: 6 }}>{principle.link}</EditorialLink> : null}
              </View>
            ))}
          </View>
        </View>
      </AboutSplit>
    </AboutSection>
  );
}

export default React.memo(AboutStory);
